import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CardChecklistAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardChecklistAll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"None"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checklists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"all"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CardChecklistAll","document":CardChecklistAllDocument}} as const;
export type CardChecklistAllQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID'];
}>;


export type CardChecklistAllQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id'>
    & { checklists: Array<(
      { __typename: 'Checklist' }
      & Pick<Types.Checklist, 'id'>
    )> }
  )> }
);




/**
 * __useCardChecklistAllQuery__
 *
 * To run a query within a React component, call `useCardChecklistAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardChecklistAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardChecklistAllQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCardChecklistAllQuery(baseOptions: Apollo.QueryHookOptions<CardChecklistAllQuery, CardChecklistAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardChecklistAllQuery, CardChecklistAllQueryVariables>(CardChecklistAllDocument, options);
      }
export function useCardChecklistAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardChecklistAllQuery, CardChecklistAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardChecklistAllQuery, CardChecklistAllQueryVariables>(CardChecklistAllDocument, options);
        }
export type CardChecklistAllQueryHookResult = ReturnType<typeof useCardChecklistAllQuery>;
export type CardChecklistAllLazyQueryHookResult = ReturnType<typeof useCardChecklistAllLazyQuery>;
export type CardChecklistAllQueryResult = Apollo.QueryResult<CardChecklistAllQuery, CardChecklistAllQueryVariables>;